<cov-side-panel-grid>
  <ng-container ngProjectAs="header">
    <div class="d-flex flex-column gap-4">
      <h2>{{ 'inquiries.sideDrawer.home.title' | transloco }}</h2>
      <p>{{ 'inquiries.sideDrawer.home.subTitle' | transloco }}:</p>
    </div>
  </ng-container>
  <div ngProjectAs="content" class="d-flex flex-column gap-4 pr-8">
    @for (question of topics(); track $index) {
      <cov-inquiry-topic-button (click)="changePage.emit(question)"
        >{{ question.question }}
      </cov-inquiry-topic-button>
    }
  </div>
</cov-side-panel-grid>
